import { render, staticRenderFns } from "./SupplierUsersList.vue?vue&type=template&id=9312dbd0&"
import script from "./SupplierUsersList.vue?vue&type=script&lang=js&"
export * from "./SupplierUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports